import { apiErrorHandler } from '../errorHandler'

export async function promoteAdmin(userId: number): Promise<void> {
  const res = await fetch(`${window.location.origin}/api/user/${userId}/promoteAdmin`, {
    method: 'POST',
    credentials: 'same-origin'
  })
  await apiErrorHandler(res)
}

export async function demoteAdmin(userId: number): Promise<void> {
  const res = await fetch(`${window.location.origin}/api/user/${userId}/demoteAdmin`, {
    method: 'POST',
    credentials: 'same-origin'
  })
  await apiErrorHandler(res)
}
